module.exports = __webpack_public_path__ + "img/aidtools_6.ef4ea8b4.png";